import React from 'react';
type Tome = {
  number: string;
  title: string;
  tag: string;
  framework: string;
  promise: string;
  band: string;
  badge: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '1',
  title: 'Your Teaching Engine',
  tag: 'The foundation',
  framework: 'The 8-Count Studio System · CLASS Anatomy · The 3-Level Dial',
  promise: 'The engine under every Bollywood class you will ever run.',
  band: 'bg-peach',
  badge: 'bg-peach-soft text-peach-deep',
  contents: ['Read and write any routine in counts with a simple notation key', 'Find the "1" in any track, no sheet music needed', 'Minute-by-minute timings for 30, 45 and 60-minute classes', 'The Teach-Back Loop: a new step to group-ready in five passes', 'Voice cues for the 20 most-used steps', 'Run one routine for a mixed-level room three ways at once']
}, {
  number: '2',
  title: 'The Beginner Term',
  tag: '10 classes',
  framework: 'The First-Term Ladder · The Confidence Curve',
  promise: 'Ten classes, one routine, and brand-new dancers who leave able to perform.',
  band: 'bg-teal',
  badge: 'bg-teal-soft text-teal-deep',
  contents: ['10 progressive Class Plans, each one building on the last', 'Week 1 ends with an 8-count your students can already show off', 'A full 96-count beginner routine, written count by count', 'Three swap-in routines: graceful, party and folk', 'The 8 beginner mistakes and the one cue that fixes each', 'Correcting without crushing, so nervous adults come back']
}, {
  number: '3',
  title: 'Kids Classes',
  tag: 'Ages 4–12',
  framework: 'The Age-Band Map · The Focus Games Method',
  promise: 'Teach children, not miniature adults.',
  band: 'bg-rose',
  badge: 'bg-rose-soft text-rose-deep',
  contents: ['What ages 4–6, 7–9 and 10–12 can really do, and how long they focus', 'Animal walks that turn into Bollywood steps for the littlest dancers', 'Reset a wild room in 60 seconds with focus games', 'The kid who won’t join, the over-excited kid, meltdowns', '6 kids routines from 32 to 64 counts', 'A four-week plan to a kids recital']
}, {
  number: '4',
  title: 'Adult & Recreational Classes',
  tag: 'Drop-in ready',
  framework: 'The Drop-In Formula · The Fitness-Flavor Dial · The Progress Anchor',
  promise: 'The grown-up room, sorted.',
  band: 'bg-sage',
  badge: 'bg-sage-soft text-sage-deep',
  contents: ['A whole class built on "everyone is new today"', 'Ready drop-in classes at 30, 45 and 60 minutes', 'One dial turns any routine into a workout or a dance night', 'Plans for date nights, hen parties, corporate teams and Diwali', 'Help adults feel their progress so they book the next term', 'A BPM playlist guide that fills the floor']
}, {
  number: '5',
  title: 'Styles, Musicality & Build-Your-Own',
  tag: 'Any song',
  framework: 'The Flavor Wheel · The Song-to-Steps Method',
  promise: 'Never run out of routines again.',
  band: 'bg-lav',
  badge: 'bg-lav-soft text-lav-deep',
  contents: ['Five Bollywood flavors and when to use each', 'Turn any track into a teachable routine in five passes', 'Map intro, verse, hook and drop, even when the tempo changes', 'A build-your-own template with two worked routines', 'Safe scarf/dupatta and stick routines, in counts', 'Theme a class for Diwali, Holi, Wedding Sangeet or Retro']
}, {
  number: '6',
  title: 'Showcases, Formations & Your Teaching Year',
  tag: 'Show & year plan',
  framework: 'The Year Map · The Formation Grid',
  promise: 'Plan the year. Stage the show. Keep them coming back.',
  band: 'bg-sky',
  badge: 'bg-sky-soft text-sky-deep',
  contents: ['A one-page Year Map, planned backward from the show date', 'A worked 36-week year for a recreational group', 'Place any group on any stage with the Formation Grid', 'A six-week showcase rehearsal plan, one job per week', 'Show-day backstage plan and live fixes', 'Fill a new class, keep a waitlist warm, run a referral loop']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="paper-grain w-full bg-paper" data-id="element-311" data-mp="3h5xfqb1h5dyf">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-312" data-mp="3uxkdkfb2eujb">
        <div className="text-center" data-id="element-313" data-mp="3v06lwh5s5e2l">
          <p className="text-sm font-semibold text-teal-deep" data-id="element-314" data-mp="3q01zkai6xp4g">The complete pack</p>
          <h2 id="tomes-heading" className="mt-3 font-display text-3xl text-navy sm:text-5xl" data-id="element-315" data-mp="8qvn0kui0vx3">
            Six volumes. <span className="wash-text" data-id="element-316" data-mp="3riv3lorsynn">A whole year, sorted.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-navy-soft" data-id="element-317" data-mp="2ai8m2t9sc9l8">
            Volume 1 is the engine the other five run on. From there, pick
            the group you teach: beginners, kids, adults, your own songs or
            the show. Each volume is 50 landscape pages, written in counts and
            ready to teach.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-318" data-mp="pzocjbzc2adb">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-3xl bg-white shadow-card" data-id="element-319" data-mp="b9h5dses0drx">
              <span className={`h-2 w-full ${tome.band}`} data-id="element-320" data-mp="2awqz3g90q9i" />
              <div className="flex flex-1 flex-col p-6" data-id="element-321" data-mp="29bwfdtxp7bn">
                <div className="flex items-center gap-2.5" data-id="element-322" data-mp="6d04dxmha4xf">
                  <span className={`flex h-9 w-9 items-center justify-center rounded-full font-display text-base ${tome.badge}`} data-id="element-323" data-mp="6adwtxzl7pf7">
                    {tome.number}
                  </span>
                  <span className="text-xs font-semibold text-navy-muted" data-id="element-324" data-mp="3thgcbcjpnym2">
                    Volume {tome.number} · {tome.tag}
                  </span>
                </div>
                <h3 className="mt-3 font-display text-2xl leading-snug text-navy" data-id="element-325" data-mp="1ros1oi4qm8w9">{tome.title}</h3>
                <p className="mt-1 text-xs font-bold text-teal-deep" data-id="element-326" data-mp="1q9pi42owmxpp">{tome.framework}</p>
                <p className="mt-2 text-sm text-navy-soft" data-id="element-327" data-mp="1l9becwuc69xh">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-paper-dark pt-4" data-id="element-328" data-mp="1ga88ja6j7zog">
                  {tome.contents.map(item => <li key={item} className="flex gap-2 text-[13px] text-navy" data-id="element-329" data-mp="1bcoxsk91m519">
                      <span className={`mt-[7px] h-1.5 w-1.5 flex-none rounded-full ${tome.band}`} data-id="element-330" data-mp="28zf7ubdt8tar" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}